// Mock data realista pra Fase 1 (substituído por backend real Fase 2)
export const mockBranding = {
    primaryColor: '#3b82f6',
    secondaryColor: '#1e40af',
    logoUrl: 'https://placehold.co/200x80/3b82f6/ffffff?text=DEMO+IPTV',
    name: 'Demo IPTV',
    locale: 'pt-BR',
    country: 'BR',
    defaultAudioLanguage: 'dubbed',
    aggressivePreload: true,
};
const CATEGORY_NAMES = [
    'Abertos',
    'Esportes',
    'Filmes',
    'Notícias',
    'Infantil',
    'Documentários',
    'Música',
    'Religiosos',
    'Variedades',
    'Adulto',
    'Internacional',
    'HBO',
    'Disney',
    'Cinemax',
    'Telecine',
    'Premiere',
    'ESPN',
    'SporTV',
    'Combate',
    'Globosat',
];
export const mockLiveCategories = CATEGORY_NAMES.map((name, i) => ({
    id: `cat-${i + 1}`,
    name,
    sortOrder: i,
}));
const CHANNEL_BASE_NAMES = [
    'Globo',
    'SBT',
    'Record',
    'Band',
    'RedeTV!',
    'CNN',
    'GloboNews',
    'BandNews',
    'Cultura',
    'TV Brasil',
    'ESPN',
    'ESPN 2',
    'ESPN 3',
    'ESPN 4',
    'SporTV',
    'SporTV 2',
    'SporTV 3',
    'Premiere',
    'Premiere 2',
    'Premiere 3',
    'Combate',
    'Telecine Premium',
    'Telecine Action',
    'Telecine Cult',
    'Telecine Fun',
    'Telecine Pipoca',
    'Telecine Touch',
    'HBO',
    'HBO 2',
    'HBO Plus',
    'HBO Family',
    'HBO Signature',
    'Cinemax',
    'Megapix',
    'Space',
    'TNT',
    'TNT Series',
    'Warner',
    'AXN',
    'FX',
    'Universal',
    'Studio Universal',
    'Sony',
    'AMC',
    'A&E',
    'History',
    'History 2',
    'Discovery',
    'Discovery Science',
    'Discovery Theater',
    'Discovery Turbo',
    'Discovery Civilization',
    'Discovery Home & Health',
    'Discovery Kids',
    'Animal Planet',
    'National Geographic',
    'Nat Geo Wild',
    'Travel Box',
    'Cartoon Network',
    'Disney Channel',
    'Disney Junior',
    'Disney XD',
    'Nickelodeon',
    'Nick Jr',
    'Tooncast',
    'Boomerang',
    'CNN Brasil',
    'CNN International',
    'BBC News',
    'Bloomberg',
    'Fox News',
    'Al Jazeera',
    'TVE',
    'RT',
    'France 24',
    'DW',
    'NHK World',
    'TV5 Monde',
    'Multishow',
    'GNT',
    'Bis',
    'Viva',
    'Off',
    'Mais Você',
    'Comedy Central',
    'MTV',
    'VH1',
    'Music Box',
    'Bandsports',
    'Esporte Interativo',
    'Fox Sports',
    'Fox Sports 2',
    'NBA TV',
    'UFC Fight Pass',
    'Eurosport',
    'Eurosport 2',
    'Tennis Channel',
    'Golf Channel',
    'Speed Channel',
    'Radical Sports',
    'Off Sports',
    'Outdoor Channel',
    'Hunt Channel',
];
const QUALITIES = ['SD', 'HD', 'FHD', '4K'];
// Gera 5000 canais combinando bases + qualidades + numeração + idiomas
function generateMockChannels() {
    const out = [];
    let idCounter = 0;
    const target = 5000;
    while (out.length < target) {
        for (const base of CHANNEL_BASE_NAMES) {
            for (const q of QUALITIES) {
                if (out.length >= target)
                    break;
                idCounter++;
                const categoryId = `cat-${(idCounter % CATEGORY_NAMES.length) + 1}`;
                const variant = Math.floor(idCounter / CHANNEL_BASE_NAMES.length / QUALITIES.length);
                const variantSuffix = variant > 0 ? ` ${variant + 1}` : '';
                out.push({
                    id: `ch-${idCounter}`,
                    name: `${base}${variantSuffix}`,
                    rawName: `${base}${variantSuffix} ${q}`,
                    logo: `https://placehold.co/120x80/1e40af/ffffff?text=${encodeURIComponent(base.slice(0, 8))}`,
                    categoryId,
                    epgChannelId: `epg-${idCounter}`,
                    quality: q,
                    codec: q === '4K' ? 'H265' : 'H264',
                    language: 'pt-BR',
                    hasArchive: idCounter % 4 === 0,
                    archiveWindowHours: 72,
                    isAdult: false,
                });
            }
            if (out.length >= target)
                break;
        }
    }
    return out;
}
export const mockLiveChannels = generateMockChannels();
export const mockVod = Array.from({ length: 200 }, (_, i) => ({
    id: `vod-${i + 1}`,
    name: `Filme Demo ${i + 1}`,
    poster: `https://placehold.co/300x450/${i % 2 === 0 ? '1e40af' : '3b82f6'}/ffffff?text=Filme+${i + 1}`,
    backdrop: null,
    plot: 'Sinopse de exemplo. Um filme demo pra testar layout e navegação.',
    year: 2020 + (i % 5),
    duration: 90 + (i % 60),
    genre: ['Ação', 'Drama', 'Comédia', 'Suspense'][i % 4],
    rating: 6 + (i % 4),
    cast: ['Ator A', 'Ator B'],
    director: 'Diretor Demo',
    categoryId: 'vod-cat-1',
}));
// EPG curto (now + next) gerado por canal
export function mockEpgShort(channelId) {
    const now = Math.floor(Date.now() / 1000);
    const slot = 60 * 60; // 1h
    const start = Math.floor(now / slot) * slot;
    return Array.from({ length: 4 }, (_, i) => ({
        id: `${channelId}-prog-${i}`,
        channelId,
        title: i === 0 ? 'Programa atual' : `Programa em ${i}h`,
        description: 'Descrição do programa.',
        startTs: start + i * slot,
        endTs: start + (i + 1) * slot,
        hasArchive: i === 0 && Math.random() > 0.5,
    }));
}
//# sourceMappingURL=mock-data.js.map